import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Download, FileText } from "lucide-react";

export default function Resources() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/resources").then((r) => setItems(r.data.resources || [])).catch(() => {});
  }, []);

  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category)))];
  const filtered = filter === "All" ? items : items.filter((i) => i.category === filter);

  return (
    <div data-testid="resources-page">
      <section className="section">
        <div className="container-editorial">
          <div className="eyebrow">Resource center</div>
          <h1 className="mt-4 font-serif text-5xl leading-[1.05] text-ink md:text-6xl">
            Tools for the <em className="not-italic text-clay">road ahead</em>.
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-muted">
            Free downloads for participants, mentors, families and partners — designed and battle-tested by the
            KEYZ community.
          </p>

          <div className="mt-10 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`resource-filter-${c.toLowerCase()}`}
                onClick={() => setFilter(c)}
                className={`rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors ${
                  filter === c ? "border-clay bg-clay text-oat" : "border-clay/25 text-ink hover:border-clay hover:text-clay"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
            {filtered.map((r) => (
              <div key={r.id} data-testid={`resource-${r.id}`} className="flex flex-col rounded-2xl border border-clay/15 bg-white p-6">
                <div className="flex items-start justify-between">
                  <div className="grid h-11 w-11 place-items-center rounded-xl bg-oat-100 text-clay">
                    <FileText className="h-5 w-5" />
                  </div>
                  <span className="text-xs font-semibold uppercase tracking-wider text-sage">{r.category}</span>
                </div>
                <h3 className="mt-5 font-serif text-xl text-ink">{r.title}</h3>
                <p className="mt-2 flex-1 text-sm text-ink-muted">{r.description}</p>
                <div className="mt-6 flex items-center justify-between">
                  <span className="text-xs text-ink-muted">{r.size}</span>
                  <button data-testid={`resource-download-${r.id}`} className="inline-flex items-center gap-2 rounded-full border-2 border-clay px-4 py-1.5 text-sm font-bold text-clay transition-colors hover:bg-clay hover:text-oat">
                    <Download className="h-4 w-4" /> Download
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
